import { defineComponent as _defineComponent } from 'vue'
import { Modal, Heading, BaseText } from '@warrenbrasil/nebraska-web';
import { Portal } from '@/modules/common/components/Portal';

interface Props {
  isOpen: boolean;
  description: string;
}

interface EmitEvents {
  (event: 'close'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ExpectedDateModal',
  props: {
    isOpen: { type: Boolean },
    description: null
  },
  emits: ["close"],
  setup(__props: any) {





return { __sfc: true,Modal, Heading, BaseText, Portal }
}

})